import React from 'react';
import PropTypes from 'prop-types';
import SearchAddIcon from '@learningblocks/exp-constants/lib/Icons/search-magnify-plus';
import SearchSubtractIcon from '@learningblocks/exp-constants/lib/Icons/search-magnify-minus';

export function ZoomInIcon(props) {
  return <SearchAddIcon className={props.className} style={{fill: 'none'}} />;
}

ZoomInIcon.propTypes = {
  /**
   * ClassName to be set on the component
   */
  className: PropTypes.string,
};

export function ZoomOutIcon(props) {
  return (
    <SearchSubtractIcon className={props.className} style={{fill: 'none'}} />
  );
}

ZoomOutIcon.propTypes = ZoomInIcon.propTypes;
